{
    "headerData1": "MyHelp",
    "headerData2": "Your AI Assistant for IT Support",
    "headerMessage": "Use <span class='me8eon'>MyHelp</span> to fix IT issues, follow step-by-step guides, or get directed to the right IT Support channel.",
    "loginLable": "Login",
    "logOff": "Logout",
    "logIn": "Login",
    "userName": "Profile name",
    "switchLanguage": "Switch language",
    "switchRole": "Switch role",
    "new": "NEW",
    "whatsnew": "See what's new",
    "whatsnewtt": "Find out what is new in MyHelp",
    "organiseTiles": "Organize tiles",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "close": "Close",
    "reset": "Reset",
    "continue_Tour": "Continue tour",
    "skip_Tour": "Skip tour",
    "save": "Save",
    "submit": "Submit",
    "delete": "Delete",
    "trash_bin": "Delete",
    "edit": "Edit",
    "yes": "Yes",
    "no": "No",
    "feedbackWidget": "Feedback",
    "registerLable": "To register ",
    "underDevelopmentMsg": "This page is under development",
    "apiFailDefaultMsg": "Something went wrong. Please try again later.",
    "more": "More",
    "searchResult": "Search Results",
    "showAll": "Show All",
    "showRelevant": "Show Relevant",
    "assistantTabTooltip": "Assistance answers your questions by searching the E.ON internal resources in real time. It gives clear, easy-to-understand answers with sources so you can trust the information",
    "searchTabTooltip": "E.ON Search is a traditional search which helps you quickly find information from different E.ON sources and your own data. It provides the most relevant results and links to the sources",
    "landingPage": {
        "hello": "Hello",
        "title": "how can I help you?",
        "searchApps": "Apps",
        "suggestions": "Suggestions"
    },
    "footer": {
        "imprint": "Imprint",
        "privacyPolicy": "Privacy Policy",
        "termsofUse": "Terms of Use",
        "contact": "Contact",
        "PKI": "PKI",
        "privacySettings": "Privacy Settings",
        "aboutMe8EON": "About MyHelp",
        "copyrights": "Copyrights Content"
    },
    "tilePage": {
        "backToSearch": "Back to previous page",
        "myInboxCountSuffix": "Pending"
    },
    "myApprovalDataTable": {
        "FilterLable": {
            "all": "All",
            "leaveApptoval": "LeaveApproval",
            "timeSheet": "TimeSheet",
            "claim": "Claim",
            "serviceRequest": "ServiceRequest "
        },
        "tableData": {
            "approve": "Approve",
            "reject": "Reject",
            "requestId": "Request Id",
            "description": "Description",
            "requestedBy": "Requested By",
            "requestedType": "Requested Type",
            "requestedDate": "Requested Date",
            "status": "Status"
        }
    },
    "appData": {
        "time": "Time-Tracking",
        "meeting": "Meeting Room Booking",
        "approval": "My Approvals",
        "pr": "Create Purchase Requisition",
        "pra": "Create Purchase Requisition Advanced",
        "processing": "My Inbox",
        "hr": "HR Portal",
        "hrLabel": "HR Portal",
        "concur": "Concur Travel Booking and Expenses",
        "password": "SAP Password Reset",
        "ariba": "Ariba - Classic and Classic+",
        "itresources": "IT Resources",
        "myassets": "My Assets",
        "order": "Order",
        "incident": "Incidents",
        "beeline": "Beeline",
        "prisma": "Prisma",
        "gertrud": "Gertrud",
        "notification": "Notification Portal",
        "zuko": "Zuko",
        "eon_brand": "EON Brand Space",
        "pki": "PKI Portal",
        "mail": "Mail DL",
        "journey": "Journeys/Events",
        "mygenius": "MyGenius",
        "ideeon": "idEE.ON",
        "ideenet": "IdeeNet",
        "dpf": "Personnel file - Digital Personnel File - DPF",
        "corpsac": "Corporate SAC",
        "corpportal": "Corporate Portal",
        "redwood": "Redwood Finance Automation",
        "eamsap200": "EAM (200)",
        "eamsap100": "EAM (100)",
        "sodsap": "SoD SAP Portal",
        "videon": "VidE.ON",
        "alteryx": "Alteryx",
        "ebam": "Banking: Bank Acc Mgmt (EBAM)",
        "egs": "E.ON Guarantee Solution",
        "epsnext": "EPSnext",
        "fisquantum": "FIS Quantum",
        "rms": "RMS - Risk Management",
        "slido": "Slido",
        "insightslibrary": "Insights Library",
        "getabstract": "getAbstract",
        "mypotential": "Achieving My Potential",
        "dsesoftware": "DSE Software",
        "whistleblowing": "E.ON Whistleblowing Solution",
        "maqsima": "MAQSIMA TMS",
        "digitalrulebook": "Paula Policy",
        "oneERP": "OneERP",
        "Perseus": "Vorfallsmeldung",
        "cateringportal": "Speiseplan",
        "westnetzregelwerke": "Regelwerke Westnetz",
        "werbemittel": "Werbemittel",
        "westenergie_brand": "Brand-Management-Portal",
        "compass": "Compass",
        "gradar": "Gradar",
        "beqom": "beqom",
        "kyc": "KYC",
        "talentry": "Talentry",
        "sam": "SAM",
        "enorm": "e-NORM",
        "redonline": "ROL",
        "tagetikcpm": "Tagetik CPM",
        "tagetikcpmerm": "Tagetik CPM and ERM",
        "smartguide": "Smart Guide",
        "tagetiksac": "Tagetik SAC",
        "myit": "my IT",
        "timehover": "With the CATS app, you can easily track and manage your work hours and activities by having all the relevant information and functions in one place.",
        "meetinghover": "With Gingco, our room booking tool, you can easily manage and schedule your meeting rooms and resources, ensuring efficient utilization and availability, all in one place",
        "approvalhover": "With myInbox, you can easily and efficiently approve invoices by having all the relevant information and actions in one place.",
        "prhover": "Here you can find all relevant functions to request goods and services. This is also known as BANF (ger. for purchase requisition)",
        "prahover": "Here you can find all relevant functions to request goods and services. This is also known as BANF (ger. for purchase requisition)",
        "processinghover": "With myInbox, you can easily and efficiently approve invoices by having all the relevant information and actions in one place.",
        "hrhover": "With myHR, you can conveniently access and manage your HR-related information and tasks in one place.",
        "concurhover": "With Concur, you can easily manage and submit your travel and expense reports by having all the relevant information and actions in one place.",
        "passwordhover": "With this tile, you can easily reset the access passwords for your SAP systems.",
        "aribahover": "With SAP Ariba, you can easily manage your procurement processes by having all the relevant information and tools in one place.",
        "itresourceshover": "IT Resources",
        "myassetshover": "My Assets",
        "orderhover": "Order",
        "incidenthover": "Incidents",
        "beelinehover": "With Beeline, you can efficiently manage your contingent workforce and streamline your staffing processes by accessing all the necessary tools and information in one place",
        "prismahover": "PRISMA stands for Platform for Reporting on Incident and Sustainability Management and Auditing. The platform supports E.ON’s HSE department in its mission to make E.ON a health-conscious, safe, and environmentally aware place. PRISMA is available both via the web and as an app.",
        "gertrudhover": "Gertrud",
        "notificationhover": "Notification Portal",
        "zukohover": "Zuko",
        "eon_brandhover": "EON Brand Space",
        "pkihover": "PKI Portal",
        "mailhover": "Mail DL",
        "journeyhover": "Journeys/Events",
        "mygeniushover": "MyGenius",
        "ideeonhover": "Idee.on is a platform that allows employees to submit and evaluate ideas and suggestions for idea management. It is designed to facilitate a continuous improvement process in all areas of the company.",
        "ideenethover": "IdeeNet is idea management software in the truest sense of the word. A wide variety of ideas, such as &#10;&bull; Centralized BVW, decentralized BVW, and mixed forms &#10;&bull; Quality circles and CIP &#10;&bull; Error reports and complaints &#10;&bull; Employee inventions &#10;can be handled efficiently with this software, in a unified ideas database, but using various strategies.",
        "dpfhover": "Your personnel file contains way more documents than those permanently displayed in MyHR! &#10;Submit an HR request and request access to your entire personnel file! After a professional review, it will be made available to you via direct link.",
        "corpsachover": "SAC is a powerful visualization tool with advanced planning capabilities",
        "corpportalhover": "The Corporate Portal is a central internal application platform with role-based application integration and development for Single-Sign-On access to SAP backends.",
        "redwoodhover": "Redwood FA is used to schedule the consolidated financial statements and automate individual activities",
        "eamsap200hover": "Enterprise Asset Management &#10;Environment for self-developments based on Business technology plattform (BTP) from SAP (formerly SAP Cloud Plattform) - EAM account for grid cockpits, including the cloud instances: production, QA (Quality Assurance), development and staging.",
        "eamsap100hover": "Enterprise Asset Management &#10;Environment for self-developments based on Business technology plattform (BTP) from SAP (formerly SAP Cloud Plattform) - EAM account for grid cockpits, including the cloud instances: production, QA (Quality Assurance), development and staging.",
        "sodsaphover": "The SOD-Portal is designed to streamline and digitize the management of Segregation of Duties (SOD). By digitizing the identification, monitoring, and resolution of SOD conflicts, it ensures compliance with regulatory standards and enhances organizational security. This tool is essential for maintaining a robust internal control system and safeguarding your business operations.",
        "videonhover": "App for booking Services from the video/TV studio at Brüsseler Platz for a video/TV production or a streaming event.",
        "alteryxhover": "Data analytics platform used for creating analytic applications and workflows. It allows users to manage and share analytic applications, run workflows, and access and report on outputs within a server environment",
        "ebamhover": "Electronic bank account management",
        "egshover": "E.ON SE takes over surety and guarantees for BU's of the group to external lenders",
        "epsnexthover": "Central electronic banking tool for all MU/Bus",
        "fisquantumhover": "The FIS Quantum Treasury Management Solution is designed to enhance the efficiency and effectiveness of your organization's treasury operations. This cloud-native platform provides real-time visibility into cash and liquidity, enabling better decision-making on capital and risk management. With advanced features for managing debt, investments, and compliance, it helps streamline workflows and improve financial performance.",
        "rmshover": "E.ON group-wide risk management system (credit application processing and credit risk management system)",
        "slidohover": "Slido is an interactive platform designed to enhance audience engagement and gather insights during live or virtual events, meetings, and presentations. It enables users to conduct live polls, Q&A sessions and quizzes in real time, creating a dynamic and participatory experience for audiences.",
        "insightslibraryhover": "Insights Library is E.ON’s central knowledge repository for customer & market insights within the customer solutions business.",
        "getabstracthover": "getAbstract is E.ON's group wide online library, provided by getAbstract, with book summaries, articles and further learning formats which cover all business relevant skills (soft skills and functional skills)",
        "mypotentialhover": "System for UK Employees and Managers to record their performance, objectives and reviews.",
        "dsesoftwarehover": "Display screen training and assessments for Health and Safety",
        "whistleblowinghover": "The Whistleblowing Tool allows anyone who provides information to submit a report anonymously. This can be done via web intake, email, or phone. During a call, your voice will be distorted.",
        "maqsimahover": "Management of risk assessments, operating instructions, hazardous substances &#10;Maqsima helps you to quickly and easily keep track of all relevant risk assessments and operating instructions and to keep them up to date in a smart way",
        "digitalrulebookhover": "Paula Policy is the AI‑based assistant for E.ON corporate policies, providing employees with fast and easy access to People Guidelines, Function Policies, and the Code of Conduct. It delivers consistent and reliable answers, making complex policies easy to understand and accessible.",
        "oneERPhover": "The one.ERP Portal is a central platform within the Westenergie Group that consolidates various ERP-related functions and information. It serves as an information and control hub for ERP users and IT managers and is part of the group’s overarching digitalization strategy.",
        "Perseushover": "The Security Portal is a central access point for reporting security-related incidents within the Westenergie and Westnetz organizations. It is frequently used in conjunction with the internal Perseus reporting system, which is specifically designed to handle incidents such as device loss, theft, or data protection breaches.",
        "cateringportalhover": "The portal eon.cateringportal.io is the digital platform for the E.ON Canteen App. It provides meal plans, location details, and other catering services for E.ON employees.",
        "westnetzregelwerkehover": "This portal serves as a central resource for technical regulations and documentation related to the operation and management of the electricity and gas networks. It ensures that all relevant guidelines, standards, and technical specifications required for safe and efficient network operations are accessible.",
        "werbemittelhover": "The Westenergie Promotional Items Shop is an online platform through which employees and authorized partners of the Westenergie Group can order promotional items and communication materials.",
        "westenergie_brandhover": "The Westenergie image database as well as the brand elements and design guidelines of the Westenergie Group. Access to all components of our brand to create Westenergie moments. From the brand management system with all important guidelines for the use of brand elements such as logos, symbols, and our chat box to the media library with numerous images for all design variants.",
        "compasshover": "Compass is the groupwide internal communication platform for E.ON news & content, networking & employee exchange.",
        "gradarhover": "This tool is used to start the grading process of leading employees.",
        "beqomhover": "Beqom is used group-wide for administration and communication of E.ON long-term incentive plans. It is used by HR, by Accounting, by Tax and by Executives. Next to long-term incentive plan matters, beqom can also be used for creation of pay and bonus letters and total reward statements.",
        "kychover": "With the Know-Your-Counterpart (KYC) tool you can screen counterparties according to standard policies (e.g.: PG-03).",
        "talentryhover": "Use this opportunity to share our current job openings with talented people in your network – people who want to help shape the future with their energy.",
        "samhover": "You can execute mandatory safety trainings with this tool.",
        "enormhover": "e-NORM is a powerful software for managing, providing, and updating data related to quality assurance or standard documents, as well as linking associated files.",
        "redonlinehover": "The Red-on-line (ROL) Compliance Monitor simplifies regulatory compliance management by providing real-time updates on environmental, health, and safety (EHS) regulations. It features monitoring and dashboards to help you proactively address compliance issues. This tool is essential for maintaining a safe and compliant workplace, reducing risks, and improving operational efficiency.",
        "tagetikcpmhover": "Tagetik Corporate Performance Management (CPM) application for budgeting & planning, consolidation, risk and Management reporting (introduced by Finance Excellence) of E.ON SE (Group Reporting). Main processes are the quarterly closings have a very high external impact due to hard deadline for capital market communication.",
        "tagetikcpmermhover": "Tagetik Corporate Performance Management (CPM) and Enterprise Risk Management (ERM) application for budgeting & planning, consolidation, risk and Management reporting (introduced by Finance Excellence) of E.ON SE (Group Reporting). Main processes are the quarterly closings have a very high external impact due to hard deadline for capital market communication.",
        "smartguidehover": "The Smart Guide Hub is a wiki that is to be maintained editorially by a few colleagues in order to provide policies for approx. 4000 users in the areas IFRS, Controlling, HGB and ESG.",
        "tagetiksachover": "Tagetik Dashboard. Tagetik is an application for budgeting & planning, consolidation, risk and Management reporting (introduced by Finance Excellence) of E.ON SE (Group Reporting). Main processes are the quarterly closings have a very high external impact due to hard deadline for capital market communication.",
        "myithover": "Your go-to for anything IT related: support options, useful links, communities and the latest news you need to know about.",
        "servicehub": "Service Hub",
        "servicehubhover": "With EON Service Hub, you can easily request new software and hardware including laptops and monitors, and get IT support by raising issues or chatting with the my IT support, all in one place.",
        "SailPoint": "Identity Management Overview",
        "P29": "SAP EIC",
        "P83": "SAP EIC",
        "BIC": "BIC Cloud / BIC Process Design",
        "Celonis": "Celonis Process Mining",
        "Carsync": "Carsync Fuhrparkmanagement",
        "ISUSpace": "ISU/Space",
        "GNIS": "GNIS (EDI)",
        "ecount_EDI": "ecount EDI",
        "SAP_Datasphere_EDI": "SAP Datasphere EDI",
        "SailPointhover": "With SailPoint, access rights and identities can be managed centrally.",
        "P29hover": "With SAP EIC, tickets and customer inquiries can be processed and documented efficiently. The application supports integration with ECG and provides a central interface for ticketing.",
        "P83hover": "With SAP EIC, tickets and customer inquiries can be processed and documented efficiently. The application supports integration with ECG and provides a central interface for ticketing.",
        "BIChover": "With BIC Cloud, business processes can be modeled, analyzed, and optimized.",
        "Celonishover": "Process Mining: Analysis of actual processes based on event logs from ERP, CRM, and other systems. Execution Management: Automation of workflows and action recommendations. Process Optimization: Identification of inefficiencies, e.g., in Purchase-to-Pay or Order-to-Cash processes. Integration: Connection to systems like SAP, Salesforce, Oracle, etc.",
        "Carsynchover": "With Carsync, company cars and vehicle fleets can be managed efficiently, trips documented, and costs optimized.",
        "ISUSpacehover": "With ISU/Space, workplaces and meeting rooms can be easily booked and managed.",
        "GNIShover": "With GNIS, master data and network data for market communication (EDI) can be managed and exchanged efficiently.",
        "ecount_EDIhover": "With eccount, EDI-relevant master and network data can be managed, exchanged, and analyzed.",
        "SAP_Datasphere_EDIhover": "With SAP Datasphere, data from various sources can be integrated, modeled, and made available for analytics and business decisions. The platform supports self-service, data governance, and real-time data access.",
        "ukhr": "UK HR App",
        "ukhrhover": "Your one stop shop for everything UK HR. From payslips to holiday booking and everything in between. Get started with our employee and manager guides or search all of HR below.",
        "CFLP": "CFLP",
        "CFLPhover": "Central point of entry for SAP-Systems and cloud services.",
        "corporateWorkspace": "Corporate Workspace",
        "corporateWorkspacehover": "SAP Build Work Zone, advanced edition lets you build digital workspace solutions to increase user productivity and engagement. It centralizes access to relevant business applications, processes, information, and communication in a unified entry point that your users can access from any device.",
        "SAPWebLaunchpad": "SAP Web Launchpad",
        "SAPWebLaunchpadhover": "The SAP Web Launchpad provides access to SAP-systems via the Web using Fiori and WebGUI. The customizable start page, including favorites, allows quick access to SAP-Systems and clients.",
        "PKI_Semnatura_Digitala_6781": "PKI - Digital Signature",
        "Users_Access_EER_9163": "RAPPS EER",
        "Evaluare_Personal_EER_2935": "Employee Evaluation EER",
        "Sesizari_Administrare_Cladiri_EER_8543": "Building Administration Reports EER",
        "MRBS_EER_8445": "MRBS EER",
        "Delegatii_EER_1137": "Business Trips EER",
        "Users_Access_EER_5369": "Users Access EER",
        "Planificare_Concedii_EER_8588": "Leave Planning EER",
        "Pontaje_si_Telemunca_EER_7087": "Time Tracking and Telework EER",
        "BOT_6231": "BOT",
        "Bonusare_personal_6879": "Employee Bonus",
        "GRC_Request_5510": "GRC Request",
        "iPEN_Portal_3047": "iPEN Portal",
        "YourVoiceEON_0693": "YourVoice@E.ON",
        "ITPortal_5530": "IT Portal (Süwag)",
        "Transf4m_Ticket_Tool_6635": "Transf4m Ticket Tool (Süwag)",
        "Speedikon_C_1281": "Speedikon C (Süwag)",
        "Speiseplan_8904": "Speiseplan (Süwag)",
        "Ariba_8690": "Ariba",
        "DiSch_20_0545": "DiSch 2.0",
        "ISMSMeldezentrale_9318": "ISMS-Meldezentrale (Süwag)",
        "SAP_Launchpad_8736": "SAP Launchpad (Süwag)",
        "HR_Portal_3311": "HR Portal (Süwag)",
        "Confluence_9100": "Confluence (Süwag)",
        "my_IT_order_6623": "my IT order",
        "BAT_Business_Activity_Tracker_7022": "BAT PL",
        "CTP_2407": "CTP PL",
        "BPM_OSD_PL_5209": "BPM OSD PL",
        "jflow_PL_6875": "jflow PL",
        "Qmatic_PL_CS_3195": "Qmatic PL CS",
        "Qmatic_PL_EN_3118": "Qmatic PL EN",
        "CCM_Inspire_7264":"CCM Inspire",
        "Atoss_artelisGruppe_und_VSEAgentur_3137": "Atoss artelis-Gruppe und VSE-Agentur",
        "Atoss_VSEGruppe_4374": "Atoss VSE-Gruppe",
        "AWS_Access_Portal_1318": "AWS Access Portal",
        "eDIVA_5372": "eDIVA",
        "G2G_VSEGruppe_6518": "G2G VSE-Gruppe",
        "AWS_Access_Portal_6740": "AWS Access Portal",
        "Qualys_Security_4331": "Qualys Security",
        "ODIN_FinOps_6411": "ODIN FinOps",
        "Cloudflare_4507": "Cloudflare",
        "ADP_TRAVEL_REISEMANAGEMENT_3368": "ADP TRAVEL REISEMANAGEMENT",
        "ITSicherheitsvorfall_melden_VSEGruppe_9292": "IT-Sicherheitsvorfall melden VSE-Gruppe",
        "HSE_Sicherheitsvorfall_melden_VSEGruppe_9987": "HSE Sicherheitsvorfall melden VSE-Gruppe",
        "Speiseplan_VSEGruppe_3571": "Speiseplan VSE-Gruppe",
        "ITMeldebogen_VSEGruppe_1367": "IT-Meldebogen VSE-Gruppe",
        "LeanIX_5372": "LeanIX",
        "VSE_Wiki_CONFLUENCE_1902": "VSE Wiki CONFLUENCE",
        "Young_Talents_AzubiPortal_3338": "Young Talents Azubi-Portal",
        "Workday_Peakon_eNPS_1749": "Workday Peakon eNPS",
        "Umantis_0386": "Umantis",
        "Adeverinte_alte_aplicatii_HR_RO_CS_2447": "Adeverinte & alte aplicatii HR (RO CS)",
        "Deconturi_card_companie_RO_CS_5333": "Deconturi card companie (RO CS)",
        "Documente_delegatii_RO_CS_5332": "Documente delegatii (RO CS)",
        "SAP_ISU_CS_RO_8555": "SAP IS-U CS RO",
        "PKI_Semnatura_Digitala_6781hover": "reset token",
        "Users_Access_EER_9163hover": "RAPPS EER",
        "Evaluare_Personal_EER_2935hover": "Employee Evaluation Portal EER",
        "Sesizari_Administrare_Cladiri_EER_8543hover": "Building Administration Reports Portal EER",
        "MRBS_EER_8445hover": "Meeting Room Booking EER",
        "Delegatii_EER_1137hover": "Business Trips Portal EER",
        "Users_Access_EER_5369hover": "User Access Form EER",
        "Planificare_Concedii_EER_8588hover": "Leave Planning EER",
        "Pontaje_si_Telemunca_EER_7087hover": "Time Tracking and Telework EER",
        "BOT_6231hover": "Rest and Treatment Ticket Reimbursement",
        "Bonusare_personal_6879hover": "Employee Bonus",
        "GRC_Request_5510hover": "GRC stands for Governance & Risk Compliance Access Control and is an SAP workflow tool for the automated request, approval, and assignment of user authorizations in SAP systems.",
        "iPEN_Portal_3047hover": "The Information Platform of Energy Networks, or iPEN for short, ensures that data from regional units can be bundled and provided centrally. Existing and newly developed intelligent solutions are connected to the platform. This allows them to be rolled out cost-effectively, quickly, and flexibly across the entire network community. iPEN is therefore the central enabler for scaling intelligent solutions.",
        "YourVoiceEON_0693hover": "The PEAKON platform sends you around 4-5 questions once a week about aspects of your well-being and your current work situation. You can rate the questions (from 0-10), comment on them, or skip them. Answering the few questions only takes about 1-2 minutes.",
        "ITPortal_5530hover": "IT Service Portal of Süwag",
        "Transf4m_Ticket_Tool_6635hover": "Transf4m Ticket Tool",
        "Speedikon_C_1281hover": "Speedikon C",
        "Speiseplan_8904hover": "Menu",
        "Ariba_8690hover": "Procurement portal",
        "DiSch_20_0545hover": "this is my digital workplace",
        "ISMSMeldezentrale_9318hover": "ISMS-Meldezentrale",
        "SAP_Launchpad_8736hover": "SAP Launchpad",
        "HR_Portal_3311hover": "HR Portal",
        "Confluence_9100hover": "Süwag Confluence",
        "my_IT_order_6623hover": "my IT order",
        "BAT_Business_Activity_Tracker_7022hover": "Time reporting",
        "CTP_2407hover": "CTP (Time is money)",
        "BPM_OSD_PL_5209hover": "BPM PP + CRM DSO",
        "jflow_PL_6875hover": "Business Processing support with jira",
        "Qmatic_PL_CS_3195hover": "Application to manage customer flow(queues) in POS",
        "Qmatic_PL_EN_3118hover": "Application to manage customer flow(queues) in POS",
        "CCM_Inspire_7264hover": "E.ON's centralized Customer Communication Management (CCM) platform powered by Quadient Inspire for creating and delivering customer communications.",
        "Atoss_artelisGruppe_und_VSEAgentur_3137hover": "This is our time tracking system",
        "Atoss_VSEGruppe_4374hover": "This is our time tracking system",
        "AWS_Access_Portal_1318hover": "Access to AWS accounts",
        "eDIVA_5372hover": "ANF user management",
        "G2G_VSEGruppe_6518hover": "GIS system of VSE-Gruppe",
        "AWS_Access_Portal_6740hover": "Access to the AWS Cloud VSE-Gruppe",
        "Qualys_Security_4331hover": "Enterprise Risk Monitoring",
        "ODIN_FinOps_6411hover": "ODIN FinOps VSE-Gruppe",
        "Cloudflare_4507hover": "Cloudflare VSE-Gruppe",
        "ADP_TRAVEL_REISEMANAGEMENT_3368hover": "ADP TRAVEL REISEMANAGEMENT  VSE-Gruppe",
        "ITSicherheitsvorfall_melden_VSEGruppe_9292hover": "Report IT security incident VSE-Gruppe",
        "HSE_Sicherheitsvorfall_melden_VSEGruppe_9987hover": "Report HSE incident VSE-Gruppe",
        "Speiseplan_VSEGruppe_3571hover": "Menu VSE-Gruppe",
        "ITMeldebogen_VSEGruppe_1367hover": "IT report form VSE-Gruppe",
        "LeanIX_5372hover": "LeanIX",
        "VSE_Wiki_CONFLUENCE_1902hover": "Guides",
        "Young_Talents_AzubiPortal_3338hover": "Young Talents Azubi-Portal VSE-Gruppe",
        "Workday_Peakon_eNPS_1749hover": "Workday Peakon eNPS",
        "Umantis_0386hover": "Umantis VSE-Gruppe",
        "Adeverinte_alte_aplicatii_HR_RO_CS_2447hover": "The purpose of this application is to allow each user to download various types of certificates with a maximum of 3 clicks. The application also has features for HR admins and team coordinators, so they can download certificates for the colleagues they have in their coordination. Additionally, employees can calculate their length of service, retirement aid, and request other documents from the HR department.",
        "Deconturi_card_companie_RO_CS_5333hover": "Through this application, company cardholders can easily submit expense claims without having to send receipts via email/mail or request approvals via email. The entire process takes place within this platform.",
        "Documente_delegatii_RO_CS_5332hover": "Using the delegations management application ('Delegatii') as a starting point, users can add documents to their own delegations as well as to those of their subordinates. HR admins have the ability to view, filter, and close delegations in bulk, as well as to request additional documents through emails automatically sent by the application.",
        "SAP_ISU_CS_RO_8555hover": "The service covers activities related with SAP IS-U x7G systems used by EON RO CS",
        "subTitle": {
            "PKI_Semnatura_Digitala_6781SubTitle": "Token renewal/rewrite",
            "Users_Access_EER_9163subTitle": "RAPPS EER",
            "Evaluare_Personal_EER_2935subTitle": "Employee Evaluation Portal EER",
            "Sesizari_Administrare_Cladiri_EER_8543subTitle": "Building Administration Reports Portal EER",
            "MRBS_EER_8445subTitle": "Meeting Room Booking EER",
            "Delegatii_EER_1137subTitle": "Business Trips Portal EER",
            "Users_Access_EER_5369subTitle": "User Access Form EER",
            "Planificare_Concedii_EER_8588subTitle": "Leave Planning EER",
            "Pontaje_si_Telemunca_EER_7087subTitle": "Time Tracking and Telework EER",
            "BOT_6231subTitle": "Rest and Treatment Ticket Reimbursement",
            "Bonusare_personal_6879subTitle": "Employee Bonus",
            "GRC_Request_5510SubTitle": "GRC Request",
            "iPEN_Portal_3047SubTitle": "Information Platform of Energy Networks",
            "YourVoiceEON_0693SubTitle": "YourVoice@E.ON",
            "ITPortal_5530SubTitle": "Süwag",
            "Transf4m_Ticket_Tool_6635SubTitle": "JIRA",
            "Speedikon_C_1281SubTitle": "Workplace reservation",
            "Speiseplan_8904SubTitle": "Höchst",
            "Ariba_8690SubTitle": "Procurement portal",
            "DiSch_20_0545SubTitle": "Digital workplace",
            "ISMSMeldezentrale_9318SubTitle": "Süwag",
            "SAP_Launchpad_8736SubTitle": "WEB",
            "HR_Portal_3311SubTitle": "Selfservices",
            "Confluence_9100SubTitle": "Süwag",
            "my_IT_order_6623SubTitle": "E.ON",
            "BAT_Business_Activity_Tracker_7022SubTitle": "Business Activity Tracker",
            "CTP_2407SubTitle": "Czas to pieniądz",
            "BPM_OSD_PL_5209SubTitle": "BPM PP + CRM DSO",
            "jflow_PL_6875SubTitle": "Business Processing",
            "Qmatic_PL_CS_3195SubTitle": "Qmatic E.ON Polska",
            "Qmatic_PL_EN_3118SubTitle": "Qmatic Stoen Operator",
            "CCM_Inspire_7264SubTitle": "CCM - Platform",
            "Atoss_artelisGruppe_und_VSEAgentur_3137SubTitle": "artelis-Gruppe und VSE-Agentur",
            "Atoss_VSEGruppe_4374SubTitle": "Atoss VSE-Gruppe",
            "AWS_Access_Portal_1318SubTitle": "IT - CloudCore",
            "eDIVA_5372SubTitle": "eDIVA ANF user management -> eDIVA",
            "G2G_VSEGruppe_6518SubTitle": "G2G VSE-Gruppe",
            "AWS_Access_Portal_6740SubTitle": "AWS Access Portal VSE-Gruppe",
            "Qualys_Security_4331SubTitle": "Qualys Security VSE-Gruppe",
            "ODIN_FinOps_6411SubTitle": "ODIN FinOps VSE-Gruppe",
            "Cloudflare_4507SubTitle": "Cloudflare VSE-Gruppe",
            "ADP_TRAVEL_REISEMANAGEMENT_3368SubTitle": "ADP TRAVEL REISEMANAGEMENT  VSE-Gruppe",
            "ITSicherheitsvorfall_melden_VSEGruppe_9292SubTitle": "IT-Sicherheitsvorfall melden VSE-Gruppe",
            "HSE_Sicherheitsvorfall_melden_VSEGruppe_9987SubTitle": "HSE Sicherheitsvorfall melden VSE-Gruppe",
            "Speiseplan_VSEGruppe_3571SubTitle": "Speiseplan VSE-Gruppe",
            "ITMeldebogen_VSEGruppe_1367SubTitle": "IT-Meldebogen VSE-Gruppe",
            "LeanIX_5372SubTitle": "LeanIX",
            "VSE_Wiki_CONFLUENCE_1902SubTitle": "VSE Wiki CONFLUENCE",
            "Young_Talents_AzubiPortal_3338SubTitle": "Young Talents Azubi-Portal VSE-Gruppe",
            "Workday_Peakon_eNPS_1749SubTitle": "Workday Peakon eNPS",
            "Umantis_0386SubTitle": "Umantis VSE-Gruppe",
            "Adeverinte_alte_aplicatii_HR_RO_CS_2447SubTitle": "Adeverinte & alte aplicatii HR (RO CS)",
            "Deconturi_card_companie_RO_CS_5333SubTitle": "Deconturi card companie (RO CS)",
            "Documente_delegatii_RO_CS_5332SubTitle": "Documente delegatii (RO CS)",
            "SAP_ISU_CS_RO_8555SubTitle": "SAP IS-U CS RO",
            "CFLPSubTitle": "Central Fiori Launchpad",
            "corporateWorkspaceSubTitle": "SAP Build Work Zone, Advanced Edition",
            "SAPWebLaunchpadSubTitle": "Links to SAP-Systems",
            "timeSubTitle": "CATS",
            "meetingSubTitle": "GINGCO",
            "approvalSubTitle": "SNOW/SAP",
            "prSubTitle": "BANF",
            "praSubTitle": "BANF",
            "processingSubTitle": "SAP",
            "hrSubTitle": "MyHR",
            "concurSubTitle": "SAP Concur",
            "passwordSubTitle": "SAP Systems",
            "aribaSubTitle": "PO Overview",
            "itresourcesSubTitle": "SNOW",
            "incidentSubTitle": "SNOW",
            "orderSubTitle": "Order IT Services",
            "myassetsSubTitle": "SNOW",
            "beelineSubTitle": "External Hiring",
            "prismaSubTitle": "HSE",
            "gertrudSubTitle": "Prepare Board Meetings",
            "notificationSubTitle": "Facility Services",
            "zukoSubTitle": "Organize Office Move",
            "eon_brandSubTitle": "it's on us",
            "pkiSubTitle": "Manage certificates",
            "mailSubTitle": "Maintain",
            "journeySubTitle": "FuV §37b EstG",
            "mygeniusSubTitle": "Digital Learning Platform",
            "ideeonSubTitle": "Ideenmanagement",
            "ideenetSubTitle": "Ideenmanagement",
            "dpfSubTitle": "Digital Personnel File",
            "corpsacSubTitle": "SAC",
            "corpportalSubTitle": "Corporate Portal",
            "redwoodSubTitle": "Redwood FA",
            "eamsap200SubTitle": "SAP Cloud Cockpits (200)",
            "eamsap100SubTitle": "SAP Cloud Cockpits (100)",
            "sodsapSubTitle": "SoD-Portal",
            "videonSubTitle": "VidEON",
            "alteryxSubTitle": "Alteryx",
            "ebamSubTitle": "EBAM",
            "egsSubTitle": "EGS",
            "epsnextSubTitle": "EPSnext",
            "fisquantumSubTitle": "FIS Quantum",
            "rmsSubTitle": "RMS",
            "slidoSubTitle": "Slido",
            "insightslibrarySubTitle": "Knowledge Repository",
            "getabstractSubTitle": "Online Library",
            "mypotentialSubTitle": "AMP",
            "dsesoftwareSubTitle": "DSE",
            "whistleblowingSubTitle": "E.ON Whistleblowing Solution",
            "maqsimaSubTitle": "Management of risk assessments",
            "digitalrulebookSubTitle": "Group Guidelines",
            "oneERPSubTitle": "EAM/ESM",
            "PerseusSubTitle": "Perseus",
            "cateringportalSubTitle": "Cateringportal",
            "westnetzregelwerkeSubTitle": "nScale",
            "werbemittelSubTitle": "Werbemittelshop",
            "westenergie_brandSubTitle": "Westenergie Frontify",
            "compassSubTitle": "Groupwide Internal Communication Platform",
            "gradarSubTitle": "Job evaluation and compensation",
            "beqomSubTitle": "beqom",
            "kycSubTitle": "Compliance Counterparty Check",
            "talentrySubTitle": "Job referral program",
            "samSubTitle": "Safety Training @E.On",
            "enormSubTitle": "Compliance Monitor",
            "redonlineSubTitle": "red-on-line",
            "tagetikcpmSubTitle": "CPM",
            "tagetikcpmermSubTitle": "CPM and ERM",
            "smartguideSubTitle": "Smart Guide Hub (Accounting Wiki)",
            "tagetiksacSubTitle": "Tagetik SAP Analytics Cloud",
            "servicehubSubTitle": "Service Hub",
            "myitSubTitle": "IT Support and News",
            "SailPointSubTitle": "Identity & Access Management Overview",
            "P29SubTitle": "SAP EIC",
            "P83SubTitle": "SAP P83",
            "BICSubTitle": "BIC Cloud",
            "CelonisSubTitle": "Process Mining",
            "CarsyncSubTitle": "Fleet Management",
            "ISUSpaceSubTitle": "Workspace and Room Management",
            "GNISSubTitle": "EDI Master Data Management",
            "ecount_EDISubTitle": "EDI Data Management",
            "SAP_Datasphere_EDISubTitle": "Data Integration & Business Data Fabric",
            "ukhrSubTitle": "UK HR App"
        }
    },
    "searchPage": {
        "searchPlaceholder": "Search...",
        "searchApps": "Search here...",
        "relatedApps": "Apps",
        "viewMoreApps": "More",
        "removeAppTooltip": "Remove from Dashboard",
        "addAppTooltip": "Add to Dashboard",
        "addedAppTooltip": "Added to Dashboard"
    },
    "pwaText": {
        "header": "Install this app on your home screen!",
        "button": "Install App",
        "iphoneHeader": "To install this app on iPhone",
        "inst1": "Tap the <b>Share</b> button in Safari.",
        "inst2": "Scroll down and select <b>\"Add to Home Screen\".</b>",
        "inst3": "Tap <b>Add</b> in the top right corner.."
    },
    "filterPage": {
        "filterMenu": {
            "backBtn": "Back to previous page",
            "enterSearchTerm": "Type your search keyword and refine your results",
            "disclaimer": "Some results may not be fully relevant. Please review carefully.",
            "loading": "Loading",
            "app": "Apps",
            "gitlab": "Gitlab",
            "apps": "Apps",
            "all": "All",
            "m365": "My Files",
            "jql": "jql",
            "people": "People",
            "emails": "My Emails",
            "teams": "Teams",
            "community": "Community",
            "pages": "Pages",
            "users": "Users",
            "noData": "We couldn't find any results for",
            "noMoreData": "No further results found for your query!",
            "filterHeading": "Filters",
            "reset": "Reset Filters",
            "refineResults": "Refine results",
            "card_languages": "Languages",
            "ecl_source_name": "Source",
            "standard_card_type": "Type",
            "mimeType": "Type",
            "datasources": "Data sources",
            "lookingFor": "I am looking for",
            "timeRange": "Time range",
            "department": "Department",
            "mygenius": "My Genius",
            "jira": "Jira",
            "confluence": "Confluence",
            "orderit": "My IT order",
            "aiAssistant": "Assistance",
            "space": "Space",
            "time": "Time",
            "priority": "Priority",
            "status": "Status",
            "compass": "Compass",
            "categoryTags": "Category",
            "kb_articles": "IT Support",
            "officeBuddy": "E.ON Knowledge base",
            "key": "Project",
            "companyTags": "Business Unit",
            "searchIn": "Search in"
        },
        "searchResult": {
            "source": "Source",
            "business": "Business",
            "mobile": "Mobile",
            "type": "Type",
            "duration": "Duration",
            "category": "Category",
            "deliveryTime": "Delivery time",
            "availableLanguages": "Available languages",
            "status": "Status",
            "lastUpdate": "Last update",
            "lastUpdated": "Last update",
            "createdOn": "Created on",
            "createdBy": "Created by",
            "company": "Company",
            "department": "Department",
            "job_title": "Job Title",
            "office_location": "Office Location",
            "email": "Email",
            "preview": "Preview",
            "viewEmail": "View Email"
        },
        "timeRangeOptions": {
            "All": "All",
            "yesterday": "1 Day",
            "lastWeek": "7 Days",
            "lastMonth": "1 Month",
            "6 Months": "6 Months",
            "lastYear": "1 Year"
        },
        "dataSources": {
            "Confluence": "Confluence",
            "Gitlab": "Gitlab",
            "JIRA": "Jira",
            "MyGenius": "MyGenius",
            "ItOrder": "my IT order",
            "Sharepoint": "SharePoint",
            "Knowledge Base": "Knowledge Base",
            "powerpoint": "PowerPoint",
            "word": "Word",
            "excel": "Excel",
            "pdf": "PDF",
            "loop": "Loop",
            "other": "Other"
        },
        "searchOptions": {
            "local": "<BU>",
            "compassWide": "All business units"
        },
        "searchOptionsHover": "Shows content from your business unit, E.ON group content or content from other business units."
    },
    "ailoader": {
        "thinking": "Thinking",
        "reading": "Reading sources",
        "processing": "Processing",
        "analysing": "Analyzing results",
        "preparing": "Preparing answer",
        "working": "Working on your answer - This may take a moment."
    },
    "chatBot": {
        "chatIcon": "ChatBot",
        "contactNumberPlaceholder": "Contact number with Country Code",
        "incidentDetailsLabel": "Summary of the incident",
        "contactNumberLabel": "Please enter your preferred contact number",
        "sourceName": "Source",
        "searchBack": "Back to previous page",
        "welcomeMessage": "Chat Prompt",
        "chatbotPlaceholder": "Type here...",
        "sendbtn": "Send",
        "cancelBtn": "Cancel",
        "searchAsk": "Describe your issue, e.g. password reset...",
        "showMore": "Show more",
        "showMoreTooltip": "Show complete answer",
        "showLess": "Show less",
        "showLessTooltip": "Minimize complete answer",
        "continueAssistance": "Continue on Assistance",
        "continueAssistanceTooltip": "Continue on Assistance to ask follow up questions",
        "feedbackTitle": "Was this helpful?",
        "feedbackThumbsUpLabel": "Yes, it helped",
        "feedbackThumbsDownLabel": "Still need help?",
        "feedbackPrompt": "Share your feedback here",
        "askMe": "Ask your querys",
        "imageUpload": "Upload Image",
        "uploadImageTooltip": "Upload Image and ask question.",
        "uploadImageFormat": "Supported format: JPG/PNG",
        "uploadImageProcessing": "Processing image...",
        "uploadImageQuestions": "Suggested Questions:",
        "card": {
            "selfService": "Self Service",
            "efficiency": "Efficiency",
            "ngService": "Next-Gen Service"
        },
        "disclaimerText": "Assistance may generate content which are inaccurate and flawed. Check important info.",
        "selfServiceTitle": "IT Support",
        "selfServiceContent": "AI-Enabled Self service support for Swift Service incident resolution",
        "knowledgeBaseTitle": "Knowledge Base",
        "knowledgeBaseContent": "Improving employee experience through information",
        "internetSearchTitle": "General Questions",
        "wentWell": "What went well? (optional)",
        "wentWrong": "What did not go well?",
        "privacyMsg": "We respect privacy and we assure feedbacks will be handled confidentially.",
        "appreciateService": "We appreciate your help in improving our services.",
        "feedbackMessage": "Thanks for your feedback!",
        "relevantSearches": "Most Relevant Searches",
        "aiAssitanceSuggestion": "You can ask your questions to AI Assistance using the input box below",
        "aiActionMsg": "It seems your internal storage is full. I can help you resolve the installation issue by automatically cleaning your temporary files and emptying your recycle bin. Do you want me to clean up automatically?",
        "aiActionPrimaryBtn": "Clean up automatically",
        "aiActionSecondaryBtn": "Don't clean up automatically",
        "aiActionSuccess": "Your storage has been cleaned up.",
        "aiActionFailed": "Something went wrong Please try after sometime. Or please try it manually.",
        "hey": "Hey",
        "topicStartMessage": "what IT issue can I help you solve today?",
        "newChat": "New Chat",
        "search": "E.ON Search",
        "open": "Open",
        "close": "Close",
        "recentChats": "Recent Chats",
        "ask": "Ask",
        "internet": "Internet",
        "askEon": "Ask E.ON",
        "askInternet": "Ask Internet",
        "askFollowUpQuestion": "Ask a follow up question",
        "resolveIssue": "Feedback submission will enable support actions",
        "resolveIssueAfterFeedback": "I'm sorry I couldn't resolve your issue. How would you like me to assist you further?",
        "differentiator": "or",
        "incident": "Raise Service ticket",
        "creatingIncident": "Creating an incident",
        "liveAgent": "Chat with an agent",
        "requestCallbackBtn": "Request Callback",
        "ticketDescription": "Ticket description based on recent discussion",
        "createIncident": "Create incident",
        "confirmCreateIncident": "Confirm and create incident",
        "editCreateIncident": "Edit and create incident",
        "ticketSuccessMsg": "Your Incident has been created successfully, Ticket Number: ",
        "ticketErrorMsg": "Something went wrong. Please try again later.",
        "incError": "Please enter valid incident details",
        "contactError": "Please enter valid contact number",
        "chatBotTitle": "Use MyHelp assistance to ask a question, get support and helpful information from internal and external sources.",
        "duplicateError": "Duplicate question, please ask a different question",
        "content": "Content",
        "tone": "Tone",
        "information": "Information",
        "complete": "Complete",
        "other": "Other",
        "irelevantContent": "Irrelevant content",
        "lackOfDetail": "Lack of detail",
        "incorrectInformation": "Incorrect information",
        "copyLink": "Copy Link",
        "openLink": "Open Link",
        "internetSearchContent": "Based on ask me anything EON gpt",
        "assignmentGroupForTicket": "eon-uk-gsd",
        "copy": "Copy",
        "share": "Share",
        "copiedMsg": "Copied Successfully",
        "copyLinkMsg": "Copy Link",
        "sharableLink": "Sharable Link",
        "uploadImage": "Upload Image and ask question",
        "liveAgentChat": {
            "connectWithLiveAgent": "Connect with my IT support",
            "connectingWithLiveAgent": "Connecting with my IT support",
            "connectingHint": "You can switch back to Assistance by clicking the link below the chat box",
            "agentLeftMsg": "Thanks for contacting E.ON",
            "switchToAssistance": "Exit chat and switch to assistance",
            "typeMessageHint": "Type your message here...",
            "disconnectingMsg": "Exiting the chat and switching to assistance",
            "continue": "Continue",
            "exitChat": "Exit chat",
            "chatSessionEndPrompt": "Chat session will auto end in <timer>"
        },
        "requestCallback": {
            "languageConfirmation": "MyHelp Assistance has detected that your default language is “<language>”. Confirm to be connected with an agent or modify the desired language and agent type below.",
            "channelsText": "Receive call back via",
            "languageText": "Communication language",
            "channelLabel": "Select Channel",
            "phoneLabel": "Connect me through",
            "languageLabel": "Select Language",
            "tryAgain": "Try Again",
            "technicalIssue": "Unable to complete your callback due to a technical issue. Please try again.",
            "newNumber": "New number",
            "availableMobileNumbers": "Available mobile numbers",
            "chosenNumber": "Connect me on this number",
            "phoneError": "Please enter a valid contact number",
            "referenceNumber": "Reference Number",
            "tooltip": {
                "confirmBtn": "Confirm to place a callback request",
                "resetBtn": "Reset the form to clear all selections and start over",
                "cancelBtn": "Cancel callback"
            },
            "addNewNumber": "new number"
        },
        "quickActions": {
            "heading": "my IT support",
            "actions": {
                "createIncident": "Create ticket",
                "chatWithServiceDesk": "Start live chat",
                "requestCallback": "Request callback",
                "ongoingConversation": "Yes, its part of my last conversation.",
                "newConversation": "No. I need help in solving new issue",
                "confirmAndCreateTicket": "Confirm and create ticket",
                "cancelTicketCreation": "Cancel ticket creation",
                "confirmChatWithServiceDesk": "Confirm and connect with my IT support",
                "cancelChatWithServiceDesk": "Cancel chat with my IT support",
                "cancelRequestCallback": "Cancel request callback",
                "confirmRequestCallback": "Confirming to connect through <channel> <phone> with a my IT support Agent in <language> language"
            },
            "state": {
                "whatsTheIssue": "What is the issue are you looking to solve?",
                "lastConversation": "Sure, is the issue part of last conversation?",
                "createIncidentLabel": "You are about to raise incident ticket for",
                "cancelAck": "Noted. Can I help you with any other issue?",
                "chatWithServiceDeskLabel": "You are about to connect with a my IT support agent",
                "createTicketLabel": "Confirm and create ticket",
                "cancelTicketLabel": "Cancel ticket creation",
                "creatingIncidentTicket": "Creating Incident ticket",
                "ticketAttachment": "Please add a screenshot of the error or issue.",
                "ticketAttachmentTooltipInstruction": "Press Windows logo key + Print screen or use snipping tool to capture an image snapshot.",
                "ticketAttachmentTooltipWarning": "Image size to be less than 5MB",
                "ticketAttachmentLabel": "Attach a Screenshot",
                "ticketAttachmentTitle": "Attached Screenshot for ticket",
                "ticketAttachmentError": "Unable to attach the selected file. Ensure the file selected is in jpg, png format and less than 5MB.",
                "ticketAttachmentErrorAction": "Try again",
                "ticketDescription": "Ticket Description",
                "ticketNonITWarning": "Assistance did not find keywords to identify your issue as an IT-related issue.",
                "ticketNonITWarningQuestion": "Do you want to create an incident with the my IT support based on your conversation about",
                "ticketNonITWarningRecommendationLabel": "Recommendation:",
                "ticketNonITWarningRecommendationText": "if you have an issue which is not related to software or hardware you can try to rephrase your search or ask a follow-up question below",
                "connectWithServiceDeskLabel": "Confirm to chat with my IT support",
                "requestCallbackLabel": "Raising a callback request",
                "requestCallbackInQueuePhone": "Your callback request has been submitted. You will be contacted in approximately 5 minutes via <strong><phone></strong>. Feel free to continue using other applications while you wait.",
                "requestCallbackInQueueTeams": "Your callback request has been submitted. You will be contacted in approximately 5 minutes via <strong>Microsoft Teams</strong>. Feel free to continue using other applications while you wait.",
                "requestCallbackFailed": "We were unable to complete your callback due to a technical issue. Please try again.",
                "requestCallbackPromptAnswer": "You are about to request a callback from my IT support",
                "requestCallbackConfirmLabel": "Confirm to request a callback"
            },
            "tooltips": {
                "createIncident": "Assists you by resolving an IT issue and creating an incident with my IT support, if needed",
                "chatWithServiceDesk": "Assists you by resolving an IT issue and contacting my IT support via chat, if needed",
                "requestCallback": "Request callback from my IT support"
            }
        },
        "askTooltip": {
            "eon": "Get company-specific information from internal sources",
            "internet": "Get information from internal and external sources such as E.ON GPT"
        },
        "jiraIntegration": {
            "viewInJira": "View in Jira",
            "responseHeading": "Here is your Jira tickets summary:",
            "responseSubheading": "Showing top 15 records",
            "noResponse": "It looks like there are no JIRA tickets available for your request right now.",
            "supportedQuestionMsg": "Hey, I am sorry. I didn't quite understand your question. Can you please rephrase it again. I am sharing some sample questions to assist you:"
        },
        "intune": {
            "selectDevice": "Select a device",
            "changeBrowserHomePage": "Change Browser Home Page",
            "fixWillBeApplied": "Fix will be applied on this system",
            "confirm": "Confirm",
            "fixThis": "Fix this",
            "enterDeviceName": "Enter device name",
            "selectOrEnterDevice": "Please select a device or enter your device name.",
            "actionFailed": "Action failed.",
            "working": "Working...",
            "fixOnThis": "Apply on this device",
            "deviceLabel": "Device",
            "lastActive": "Last active",
            "today": "Today",
            "yesterday": "Yesterday",
            "daysAgo": "days ago",
            "deviceTypeLaptop": "Laptop",
            "deviceTypeDesktop": "Desktop",
            "deviceTypeVirtualMachine": "Virtual Machine",
            "deviceTypeUnknown": "Device",
            "homepageBrowserChange": {
                "syncInstructions": "The change will be applied now to your device. This can take about 30 minutes. If you wish to speed up the process, you can initiate a manual sync from Company Portal:\n1. Open Company Portal\n2. On the bottom left, click on Settings next to the gear symbol.\n3. Then click on the blue \"Synchronize\" button, and wait for the synchronization to complete.",
                "changeHomepageInstructions": "1. Click the three dots (...) in the top-right corner.\n2. Select “Settings”.\n3. In the left menu, select “Start, home, and new tab page”.\n4. Under “On startup”, make sure “Open custom sites” is selected/checked.\n5. Then click “Add site”.\n6. Enter the website address that you want to set as your new Homepage in Microsoft Edge (for example: https://compass.eon.com/).\n7. Click “Add”.\n\nIf you want to remove a site from the Homepage list, click the three dots (...) next to the site, and click “Remove”.",
                "policyDescription": "Your organisation currently manages browser homepage settings through device policies. To enable homepage modification, we first need to identify which device should receive the policy update.",
                "deviceSelectedForPolicy": "selected for home page policy unlock",
                "stepsForEdge": "Steps to change the Homepage in Microsoft Edge",
                "whatsNextTitle": "What happens next?",
                "whatsNextSubmitted": "A request to allow customizable homepage has been submitted to your device policy queue.",
                "whatsNextSyncTime": "<strong>30 minutes</strong> average sync time needed for the background policy refresh.",
                "whatsNextReturn": "Please return to your browser settings after 30 minutes and perform the below steps.",
                "homepageEnabled": "You can now change your browser homepage settings. Please note that the change may not take effect immediately. Wait approximately 30 minutes for the synchronization to take place, then close and re-open Edge.",
                "homepageAlreadyEnabled": "Your device already has homepage change enabled. Go to browser settings and try again.",
                "homepageEnableFailed": "I couldn't enable homepage change right now. Please try again later.",
                "homepageRemoved": "Device removed from homepage policy group."
            }
        },
        "nexthinkIntegration": {
            "failureMsg": "Oops! Something went wrong. Please try again later. If the issue persists please raise an issue from Quick Actions",
            "assistanceTask": "Assistance Task",
            "myActions": "My Actions",
            "itReportTitle": "Here is your systems energy efficiency snapshot",
            "days": "Days",
            "device": "Device",
            "sinceRestarted": "since restarted",
            "deviceRestartRecommendation": "Immediate device restart is recommended",
            "deviceInCompliance": "Your device is in compliance",
            "energyConsumed": "Energy Consumed in last 7 days",
            "coEmitted": "CO2 Emitted in last 7 days",
            "cacheActionMsg": "Please relaunch your browser for the changes to take effect.",
            "declineScriptMsg": "I don't want to run the Nexthink script, assist me with other solution",
            "errorFetchingReport": "Sorry, I couldn't fetch the report. Please try again later.",
            "recommendedAction": "Recommended Action",
            "noKbArticleFound": "No manual steps or knowledge articles were found for this issue. However, there is a recommended action that may resolve it:",
            "chooseBrowser": "Choose browser for cache cleanup action",
            "automatedFix": "Automated Fix",
            "automatedFixConsent": "I can resolve this issue on your device. Would you like me to initiate the automatic fix?",
            "primaryButton": "Yes, initiate the fix",
            "diskClean": {
                "primaryBtn": "Yes, clean up my disk now",
                "secondaryBtn": "Don't clean up now",
                "successMsg": "Your disk has been cleaned up",
                "successMsgOnList": "Your disk has been cleaned up",
                "failureMsg": "Your disk could not be cleaned up at this point",
                "progressMsg": "Clearing up storage in progress",
                "acknowledgeQuery": "I can perform disk cleanup for you. During disk cleanup unnecessary files, caches or old logs in your system are cleaned up. Please click on the button below to proceed.",
                "disclaimer": "Please note we will not touch your personal or work data. While clean-up takes place in the background, feel free to use assistance."
            },
            "chromeCache": {
                "primaryBtn": "Yes, clear chrome cache now",
                "secondaryBtn": "Don't clear chrome cache now",
                "successMsg": "Your chrome cache has been cleaned up. Please relaunch your browser for the changes to take effect.",
                "successMsgOnList": "Your chrome cache has been cleaned up",
                "failureMsg": "Your Chrome Cache could not be cleaned up at this point",
                "progressMsg": "Clearing up chrome cache in progress",
                "acknowledgeQuery": "I can help you clear the browser cache. Please click on the button below to proceed.",
                "disclaimer": "Please note we will not touch your personal or work data. While clean-up takes place in the background, feel free to use assistance."
            },
            "edgeCache": {
                "primaryBtn": "Yes, clear edge cache now",
                "secondaryBtn": "Don't clear edge cache now",
                "successMsg": "Your edge cache has been cleaned up. Please relaunch your browser for the changes to take effect.",
                "successMsgOnList": "Your edge cache has been cleaned up",
                "failureMsg": "Your edge Cache could not be cleaned up at this point",
                "progressMsg": "Clearing up edge cache in progress",
                "acknowledgeQuery": "I can help you clear the browser cache. Please click on the button below to proceed.",
                "disclaimer": "Please note we will not touch your personal or work data. While clean-up takes place in the background, feel free to use assistance."
            },
            "empowerApp": {
                "primaryBtn": "Yes, please repair now",
                "secondaryBtn": "Don't repair now",
                "successMsg": "Auto repair successfully completed",
                "successMsgOnList": "Auto repair successfully completed",
                "failureMsg": "Your Empower Plugin could not be repaired at this point",
                "progressMsg": "Auto repair is in progress",
                "acknowledgeQuery": "I can assist you with the issues related to Empower add-in, Please click below to repair empower plugin.",
                "disclaimer": "We will be reinstalling the Empower plugin, Please close all your O365 Apps before proceeding further."
            },
            "teamsCache": {
                "primaryBtn": "Yes, clear Teams cache now",
                "secondaryBtn": "Don't clear Teams cache now",
                "successMsg": "Your Teams cache has been cleared up. You can open Teams and reconfigure any settings that might have been reset.",
                "successMsgOnList": "Your Teams cache has been cleaned up",
                "failureMsg": "Your Teams Cache could not be cleaned up at this point",
                "progressMsg": "Clearing up Teams cache in progress",
                "acknowledgeQuery": "I can help you clear the Teams cache. Please click on the button below to proceed.",
                "disclaimer": "Please note we will not touch your personal or work data. While clean-up takes place in the background, feel free to use assistance."
            },
            "teamsReinstall": {
                "primaryBtn": "Yes, reinstall Teams",
                "secondaryBtn": "Don't reinstall Teams",
                "successMsg": "Teams App reinstall is completed",
                "successMsgOnList": "Teams App reinstall is completed",
                "failureMsg": "Teams reinstall could not be completed",
                "progressMsg": "Teams reinstall in progress",
                "acknowledgeQuery": "Re-installing the Microsoft Teams app might fix the issue. Please click on the button below to proceed.",
                "disclaimer": "Please note that this will simultaneously download and reinstall Teams App. This will restart Teams app, please save your work before proceeding further."
            },
            "outlookOst": {
                "primaryBtn": "Yes, Repair Outlook",
                "secondaryBtn": "Don't repair Outlook",
                "successMsg": "Outlook Profile recreated",
                "successMsgOnList": "Outlook Profile recreated",
                "failureMsg": "Outlook Profile could not be recreated",
                "progressMsg": "Recreating Outlook profile",
                "acknowledgeQuery": "This could be due to connection issues or outdated settings. I can help you troubleshoot and get your Outlook back in sync.",
                "disclaimer": "Executing this action will recreate your Outlook profile locally, this will intiate download of emails from office Exchage, please ensure that enough network bandwidth and storage is available."
            },
            "repairOfficeApps": {
                "primaryBtn": "Yes, Repair Office apps",
                "secondaryBtn": "Don't Repair Office apps",
                "successMsg": "Office apps repaired",
                "successMsgOnList": "Office apps repaired",
                "failureMsg": "Office applications could not be repaired",
                "progressMsg": "Office Apps are being reinstalled",
                "acknowledgeQuery": "This could be due to a corrupted installation or compatibility issue. I can help you repair Office apps so your apps open smoothly.",
                "disclaimer": "Executing this action will simultaneously reinstall office apps and attempt to repair them, please save all unsaved work before proceeding."
            },
            "intuneSync": {
                "primaryBtn": "Yes, initiate intune sync",
                "secondaryBtn": "Don't initiate Sync",
                "successMsg": "Intune Sync has been completed",
                "successMsgOnList": "Intune Sync has been completed",
                "failureMsg": "Intune Sync could not be Initiated",
                "progressMsg": "Intune Sync in progress",
                "acknowledgeQuery": "I can help you refresh your device's status and sync it with Intune to ensure it is compliant, updated, and applying the latest policies.",
                "disclaimer": "Please note that this action is only restarting Intune Sync services, this does not reinstall or repair Intune(Company portal)."
            },
            "teamsAddin": {
                "primaryBtn": "Yes, enable MS Teams add-in",
                "secondaryBtn": "Don't enable the Add-in",
                "successMsg": "MS Teams add-in repair is completed",
                "successMsgOnList": "MS Teams add-in repair is completed",
                "failureMsg": "MS Teams Add-in could not be enabled",
                "progressMsg": "MS Teams add-in is being enabled",
                "acknowledgeQuery": "I can help restore the Teams add-in in Outlook so you can schedule meetings again. Please click the button below to continue.",
                "disclaimer": "Please note that repairing the MS Teams add-in requires Outlook to be restarted. Please save all your work before proceeding."
            },
            "windowsUpdate": {
                "primaryBtn": "Yes, check for updates",
                "secondaryBtn": "No, don't check",
                "successMsg": "Windows Update was triggered",
                "successMsgOnList": "Windows Update was triggered",
                "failureMsg": "Unable to trigger Windows Update",
                "progressMsg": "Checking for Updates",
                "acknowledgeQuery": "I can assist in resolving Windows update and compliance issues on your device. Please click the button below to continue",
                "disclaimer": "This action is designed to check and download updates from Microsoft, please ensure you are connected to a suitable network, to download any updates."
            },
            "timezone": {
                "primaryBtn": "Yes, Proceed further",
                "secondaryBtn": "No, don't update",
                "successMsg": "Timezone detection has been set to automatic",
                "successMsgOnList": "Timezone detection has been set to automatic",
                "failureMsg": "Timezone configuration could not be updated",
                "progressMsg": "Updating the timezone settings",
                "acknowledgeQuery": "I can help you fix your system time and timezone settings. Most time-related issues like clock drift, wrong timestamps, failed authentication codes or incorrect meeting times are caused by incorrect timezone or disabled auto-sync settings. Please click on the button below to automatically detect and fix your Windows time and timezone configuration.",
                "disclaimer": "Please note that, this action is desiged to set the Time Zone service to automatic, allowing windows to update the desktop clock based on detected location."
            },
            "outlookAutoComplete": {
                "primaryBtn": "Yes, Clear Outlook cache",
                "secondaryBtn": "No, Do not clear Outlook cache",
                "successMsg": "Outlook autocomplete cache cleaned",
                "successMsgOnList": "Outlook autocomplete cache cleaned",
                "failureMsg": "Outlook autocomplete cache could not be cleaned",
                "progressMsg": "Clearing Outlook autocomplete cache",
                "acknowledgeQuery": "I can help you fix your Outlook autocomplete cache. Please click on the button below to automatically fix your Outlook autocomplete.",
                "disclaimer": "Please note that, Clearing the Outlook autocomplete cache will remove saved email address suggestions.This action cannot be undone."
            },
            "restartZscalar": {
                "primaryBtn": "Yes, Proceed further",
                "secondaryBtn": "No, Do not restart Zscaler",
                "successMsg": "Zscaler restarted",
                "successMsgOnList": "Zscaler restarted",
                "failureMsg": "Zscaler could not be restarted",
                "progressMsg": "Restarting Zscaler services",
                "acknowledgeQuery": "I can help you fix your Zscaler services issue. Please click on the button below to fix your Zscaler issues.",
                "disclaimer": "Please note that, Restarting Zscaler can briefly disconnect your internet and work applications.This usually takes less than a minute."
            },
            "onedrive": {
                "primaryBtn": "Yes, repair OneDrive",
                "secondaryBtn": "No, do not run the OneDrive repair",
                "successMsg": "The OneDrive repair has been completed",
                "successMsgOnList": "The OneDrive repair has been completed",
                "failureMsg": "The OneDrive repair action could not be completed successfully",
                "progressMsg": "Running OneDrive repair",
                "acknowledgeQuery": "I can help you fix your OneDrive issues. Please click on the button below to fix your OneDrive issues.",
                "disclaimer": "Please note that, Repairing can OneDrive will cause local files to be synced to the cloud and may potentially break custom syncs for Onedrive"
            },
            "smartcard": {
                "primaryBtn": "Yes, remove Smart card",
                "secondaryBtn": "No, do not remove the Smartcard",
                "successMsg": "The Microsoft Smartcard has been Removed",
                "successMsgOnList": "The Microsoft Smartcard has been Removed",
                "failureMsg": "Unable to remove Microsoft Smartcard",
                "progressMsg": "Removing Microsoft Smartcard",
                "acknowledgeQuery": "I can help you fix the Microsoft Smart Card Reader issues. Please click on the button below to fix your Smart Card issues.",
                "disclaimer": "Executing this action can take up to 1 minute."
            },
            "teamViewerReset": {
                "primaryBtn": "Yes, proceed further",
                "secondaryBtn": "No, do not reset",
                "successMsg": "Teamviewer services have been reset",
                "successMsgOnList": "Teamviewer services have been reset",
                "failureMsg": "Unable to reset Teamviewer services",
                "progressMsg": "Teamviewer services are being restarted",
                "acknowledgeQuery": "I can help reset the Teamviewer. Please click the button below to continue.",
                "disclaimer": "This action will reset your teamviewer services and restart your teamviewer app, please ensure your work is saved before proceeding"
            },
            "zoomUninstall": {
                "primaryBtn": "Yes, Uninstall Zoom",
                "secondaryBtn": "No, do not uninstall",
                "successMsg": "Zoom Uninstalled",
                "successMsgOnList": "Zoom Uninstalled",
                "failureMsg": "Unable to remove Zoom",
                "progressMsg": "Zoom Uninstallation in progress",
                "acknowledgeQuery": "I can help uninstall Zoom. Please click the button below to continue.",
                "disclaimer": "This action will uninstall Zoom from your device, this will also clear all the configurations for Zoom."
            },
            "webexUninstall": {
                "primaryBtn": "Yes, Uninstall Webex",
                "secondaryBtn": "No, do not uninstall",
                "successMsg": "Webex Uninstalled",
                "successMsgOnList": "Webex Uninstalled",
                "failureMsg": "Unable to remove Webex",
                "progressMsg": "Webex Uninstallation in progress",
                "acknowledgeQuery": "I can help uninstall Cisco Webex. Please click the button below to continue.",
                "disclaimer": "This action will uninstall Cisco Webex from your device, this will also clear all the configurations for Cisco Webex."
            },
            "smartSolution": {
                "systemName": "System Name",
                "primaryBtn": "Request Healthcheck",
                "secondaryBtn": "Not now",
                "acknowledgeQuery": "I can help troubleshoot the issue with your device. Let's check and resolve the issue",
                "askToRunHealthCheck": "Would you like the assistance to perform a quick health check?",
                "healthCheckApiRunning": "Analyzing and Performing Health Check On",
                "healthCheckApiFail": "Failed to fetch health check info, please try again",
                "healthCheckApiSuccess": "I have analysed the system. Following issues persists:",
                "systemCheckMsg": "System check in progress",
                "systemCheckMessages": {
                    "recentlyStarted": "System is up to date and recently started",
                    "appsHealthy": "All the apps installations are healthy",
                    "driveSpace": "Ample system drive free space available",
                    "noCrashes": "No application crash detected recently"
                },
                "healthCheckNoIssue": "I have analysed the system. <b>Everything seems to be working properly.</b>",
                "recommendedActionHeading": "Recommended Actions",
                "askForElaboration": "You can also elaborate the specific issue or can upload the screenshot of issue you are facing.",
                "remindForSystemCheck": "Okay you can let me know whenever you like to perform a system check.",
                "recommendedFixesHeading": "Recommended Fixes",
                "recommendedActionInfo": "Select or deselect the proposed fixes, if needed",
                "noRecommendedAction": "No recommended actions available",
                "initiateActionsButton": "Start Fixing",
                "selectedActionsProgress": "Selected actions are being processed.",
                "selectedActionsProgressNote": "Please feel free to use the assistance while the action is been performed. Your action item has been added to the assistance task list and you  can check the progress, You will be notified once the action has been completed.",
                "selectedActionsCompleted": "Selected actions completed successfully.",
                "selectedActionsFailed": "Selected actions failed. Check Assistance task card for details.",
                "selectedActionsPartiallyCompleted": "Selected actions are partially completed. Check Assistance Task card for details.",
                "myActionDone": "Mark as done",
                "manualActionDisclaimer": "This process includes both automated and manual steps. Please complete actions when requested",
                "manualActionNotification": "To finalize the fix please perform additional step(s) manually mentioned under 'My Actions'.",
                "deviceSelectionHeading": "I could see you are using multiple systems. If you would like to perform following action on different system please choose from the list below.",
                "deviceSelectionLabel": "Choose the system for Nexthink action",
                "alerts": {
                    "successTitle": "Task complete!",
                    "successMessage": "Selected actions have been completed successfully.",
                    "errorTitle": "Task failed!",
                    "errorMessage": "There was an error processing your selected action.",
                    "partialTitle": "Task completed partially",
                    "partialMessage": "Selected actions are partially completed. Check Assistance Task card for details."
                },
                "reportAndAction": {
                    "systemCrashes": {
                        "message": "There has been <n> occurrences of Blue screens on your device in the last 7 days.",
                        "action": "Please contact GSD for further help",
                        "actionInfo": "(No action) please contact GSD for further  assistance"
                    },
                    "edgeCrashes": {
                        "message": "We have found evidence of <n> browser Edge crashes in last 7 days. We will attempt to remediate this by running a script on your machine.",
                        "action": "Clear Edge browser cache",
                        "actionInfo": "This clears Edge browser caches & not personal file are modified"
                    },
                    "chromeCrashes": {
                        "message": "We have found evidence of <n> browser Chrome crashes in last 7 days. We will attempt to remediate this by running a script on your machine.",
                        "action": "Clear Chrome browser cache",
                        "actionInfo": "This will clear your Chrome cache, no existing files are modified."
                    },
                    "ZScalarStatus": {
                        "message": "We found that the Zscaler service had run into a few problems on your device. We can attempt to remediate this by running a script on your machine.",
                        "action": "Restart Zscaler service",
                        "actionInfo": "This action will restart the network connecton. It does not have any impact on your open programs."
                    },
                    "ZScalarState": {
                        "message": "We found that the Zscaler service had run into a few problems on your device. We can attempt to remediate this by running a script on your machine.",
                        "action": "Reset Zscaler",
                        "actionInfo": "This action will restart the network connection. It does not have any impact on your open programs."
                    },
                    "driveFreeSpace": {
                        "message": "Your device has only <n> GB  of free space remaining. To ensure an optimum performing computer, we recommend increasing the amount of free space available for Windows to use, by running a script on your machine.",
                        "action": "Perform Disk Cleanup",
                        "actionInfo": "Only your temporary files and recycle bin of your device is cleaned in the action"
                    },
                    "daysSinceFullBoot": {
                        "message": "Your device has not been fully restarted in the last <n> days. This is different to the normal Shutdown procedure. We recommend fully Restarting your Computer (Start | Shutdown | Restart)",
                        "action": "Restart Device at your earliest convenience.",
                        "actionInfo": ""
                    },
                    "teamsCrashes": {
                        "message": "We found evidence of <n> related Microsoft Teams crashes, in the last 7 days. We can attempt to remediate this by running a script to clear your Microsoft Teams cache.",
                        "action": "Run Teams cache cleanup",
                        "actionInfo": "This action clears your MS Teams cache and restarts it. This will also can delete Draft / Unsent Teams messages."
                    },
                    "teamsPluginDisabled": {
                        "message": "We have detected that your Microsoft Teams add in within Microsoft Outlook. This causes issues between the 2 applications. We can attempt to remediate this by running a script to reconfigure these settings.",
                        "action": "Set Outlook Plugins",
                        "actionInfo": "This action enables the Teams plug-in in your Outlook and restarts the app."
                    },
                    "outlookOstStatus": {
                        "message": "Your Outlook profile has exceeded its optimal size, which is known to cause issues with your Mailbox, We can attempt to remediate this with a script to recreate this file.",
                        "action": "Repair Outlook OST file",
                        "actionInfo": "This renames your outlook OST file and restarts the app. It will delete any draft emails."
                    },
                    "lastOsUpdate": {
                        "message": "We can see that your Windows Update service is not running as expected, and your machine was last updated <n> days ago. We recommend fully Restarting your Computer (Start | Shutdown | Restart) which helps to reset a few settings.",
                        "action": "Restart Device at your earliest convenience",
                        "actionInfo": ""
                    }
                }
            }
        },
        "sessions": {
            "title": "Recent Chats",
            "clearAll": "Delete all chats",
            "deleteMessage": "Delete session",
            "footer": "Note: Last 30 days conversation will be stored.",
            "noRecentChat": "No recent chats",
            "startNewChat": "Start New Chat",
            "learnMore": "Learn More.",
            "learnMoreTooltip": "According to MyHelp retention policy your recent chats will be available for 30 days unless you delete the recent chats using the delete or clear all buttons."
        },
        "feedbackMsg": "Thank you for your Feedback! We appreciate your help in improving our services.",
        "teamsInsights": {
            "specifyDateTime": "Could you please specify the date and time this occured, as well as the specific meeting or chat involved?",
            "date": "Date",
            "getMeetings": "Get Meetings",
            "cancel": "Cancel",
            "noMeetings": "No meetings found for the selected date.",
            "meetingInstruction": "Please select the specific meeting that was affected by the quality issues.",
            "identifyIssue": "Identify the issue",
            "issueDetectionCompleted": "Issue detection completed.",
            "detectingIssues": "Detecting issues with the meeting",
            "recommendedActions": "Recommended Actions:",
            "noInsightsFound": "No insights found for the selected call.",
            "meetingList": "Meeting List",
            "fetchingMeetings": "Fetching all Teams meetings for the day",
            "windowsOnly": "Meeting insights are only available in the calls joined using Windows devices.",
            "confirmCreateIncident": "Do you want to create an incident ticket for the issue detected in the meeting?",
            "getMeetingsCancelMsg": "Get Meetings request cancelled.",
            "identifyIssueCancelMsg": "Identify issue request cancelled.",
            "createIncidentCancelMsg": "Create incident request cancelled.",
            "report": {
                "lowWifiRootCause": "Your WiFi Signal during the call was low and this might have caused quality issues during the call. Please check your distance from your router if you were connected from a home/remote network.",
                "networkIssueRootCauseManaged": "It looks like you were connected from an E.ON office and you have expererienced network issues impacting the meeting quality. Please consider opening a incident ticket to report it and mention the location you have been in the ticket.",
                "networkIssueRootCauseUnmanaged": "It looks like you were not connected from an E.ON office and have experienced network issues that may have impacted meeting quality. Please check the stability of your local Wi-Fi or internet connection. If possible, use a wired connection or move closer to your Wi-Fi router to improve network performance.",
                "noDataRootCause": "No insights was available for this parameter during the call.",
                "noIssueRootCause": "No issue detected for this parameter.",
                "noIssueRecommendation": "No action required.",
                "failed": "Failed",
                "checking": "Checking",
                "okay": "Okay",
                "na": "NA",
                "audio": "Audio",
                "video": "Video",
                "deviceCpuUsage": {
                    "displayName": "Device CPU Usage",
                    "rootCause": "We have detected a high CPU load during the call on your device. Please check if you had any background processes or Apps open and running while you have been in the call and avoid to have too many apps open while being on a call to ensure the devices hardware performance can be allocated to the meeting.",
                    "recommendation": "Close unnecessary background applications while on calls to reduce CPU load."
                },
                "deviceMemoryUsedPct": {
                    "displayName": "Device Memory Usage",
                    "rootCause": "We have detected a high memory usage during the call on your device. Please check if you had any background processes or Apps open and running while you have been in the call and avoid to have too many apps open while being on a call to ensure the devices hardware performance can be allocated to the meeting.",
                    "recommendation": "Close unnecessary background applications while on calls to reduce memory usage."
                },
                "wifiSignalQuality": {
                    "displayName": "WiFi Signal Quality",
                    "recommendation": "Move closer to your router or switch to a stronger WiFi signal source."
                },
                "audioJitter": {
                    "displayName": "Audio Jitter"
                },
                "audioJBDelay": {
                    "displayName": "Audio JB Delay"
                },
                "audioRecvLossRate": {
                    "displayName": "Audio Receive Loss Rate"
                },
                "audioRtt": {
                    "displayName": "Audio Round Trip Time"
                },
                "videoRtt": {
                    "displayName": "Video Round Trip Time"
                },
                "videoRecvLossRate": {
                    "displayName": "Video Receive Loss Rate"
                },
                "wifiChannelCenterFrequencyInKilohertz": {
                    "displayName": "WiFi Channel Center Frequency (kHz)",
                    "rootCause": "You are using 2.4 Ghz WiFi connection, which frequently causes call quality issues. Please consider changing to a 5Ghz WiFi Band or higher.",
                    "recommendation": "Switch to a 5 GHz (or higher) WiFi band to improve call quality."
                },
                "wifiSsidChangeDetected": {
                    "displayName": "Network change Detected",
                    "rootCauseManaged": "We have identified WiFi or Access Point changes during your call in an EON office. This might have caused an disruption of the call. If you were not moving with your device , please kindly register this as an incident ticket.",
                    "rootCauseUnmanaged": "We identified that you were not connected from an E.ON location. Please check that your Wi-Fi connection is stable, as network issues may affect meeting quality."
                }
            }
        }
    },
    "snow": {
        "welcomeNote": "Please find below an overview about your open incident tickets, your requests and your IT assets.",
        "tabName": {
            "incidents": "Incidents",
            "orders": "Orders",
            "itResources": "IT Resources",
            "incidentsTable": {
                "noData": "No available data",
                "btnText": "Open new Incident",
                "ongoing": "Ongoing",
                "closed": "Closed",
                "headlineText": "Incidents"
            },
            "orderTable": {
                "number": "Number",
                "catItem": "Cat Item",
                "approvalSet": "Approval Set",
                "state": "State",
                "dueDate": "Due Date",
                "createdOn": "Created On",
                "noData": "No available data",
                "btnText": "Order IT Services",
                "headlineText": "Orders",
                "tooltipText": "Request and manage IT equipment, software, licences or services"
            },
            "itResourcesTable": {
                "modelCategory": "Model Category",
                "model": "Model",
                "computerName": "Computer Name",
                "serialNumber": "Serial Number",
                "serviceValue1": "Service Value1",
                "serviceValue2": "Service Value2",
                "noData": "No available data",
                "btnText": "Open a ticket for IT resources",
                "headlineText": "My Assets"
            }
        }
    },
    "moveTabAndTiles": {
        "tabNames": "Tab",
        "favourite": "Favourite",
        "categorizeTiles": "Personalized dashboard",
        "enterTabName": "Enter tab name",
        "tabNameError": "Please enter unique Tab name, with minimum 2 to max 20 length!",
        "tabInputLabel": "Tab name",
        "addTabButton": "Add tab",
        "personalizeTab": "Personalize tabs",
        "personalizeTiles": "Personalize tiles",
        "addTab": "Add new tab",
        "removeTabConfrim": "Are you sure to remove the Tab",
        "with": " with",
        "cardIn": "tiles in?",
        "actionUndone": "This action cannot be undone.",
        "categorizeTilesTitle": "Rename tabs, Remove tabs and move tiles within tabs",
        "addTabTitle": "Add new tab. You can create maximum 4 tabs.",
        "organiseTilesTitle": "To move the position of the Tiles"
    },
    "dataTable": {
        "pagingData": "Items per page",
        "itemString": "items",
        "ofString": "of"
    },
    "tourData": {
        "userActions": {
            "back": "Back",
            "close": "Close",
            "last": "Finish",
            "next": "Next",
            "step": "Step",
            "of": "of",
            "open": "Open the dialog",
            "skip": "Skip",
            "start_tour": "Start tour",
            "tour_info": "Would you like us to show you the basic functionalities with a quick guided tour? It should only take 1-2 minutes..."
        },
        "tile": {
            "step1": "Use MyHelp to find your typical work applications or ask any question across E.ON resources, for example IT, your projects, trainings, company policies and many more.",
            "step2": "You can find out more about MyHelp and its functions, find answers to frequently asked questions and learn helpful tips and tricks in the user documentation.",
            "step3": "You can still change the preferred language anytime from here.",
            "step4": "You can logout by clicking here.",
            "step5": "Start fresh with New Chat in Assistance, revisit your Recent Chats to pick up where you left off or start an E.ON search by clicking on the magnifying glass.",
            "step6": "Your personalized dashboard lets you organize and access your favorite work applications. Search for an app and add it with the plus symbol. Create new tabs and rearrange apps as needed."
        },
        "tab": {
            "step1": "You can add new tab by clicking here.",
            "step2": "Click here to organize the sequence of the tiles.",
            "step3": "Here you can rename and organize tabs."
        },
        "chat": {
            "step1": "Describe your IT issue",
            "step1_description": "Get step-by-step help for common IT issues, based on E.ON support knowledge bases. MyHelp can also guide you to the right IT support channel if needed.",
            "step2": "Explore common IT topics",
            "step2_description": "These examples show common IT topics and requests that MyHelp can help you resolve step by step.",
            "step3": "Access your apps faster",
            "step3_description": "Use the Dashboard to save frequently used applications and create your own personalized workspace.",
            "step4": "Start a new chat or continue previous conversations",
            "step4_description": "Use the side navigation to start a new conversation or quickly return to recent chats."
        }
    },
    "allApps": {
        "addAppsBtn": "Add Apps",
        "addAppsInfo": "Click on Add apps to get started",
        "addAppsTitle": "Build your personalized workspace",
        "addAppsDesc": "Add your most used applications for quicker access to the tools you use every day",
        "customTileButton": "Add custom card",
        "CustomTileHeading": "Custom Card",
        "customTileTitleLabel": "Card Title",
        "customTileSubTitle": "Card Description",
        "customTileUrlLabel": "Card Link",
        "createCardBtn": "Create card",
        "modalHeading": "Apps on E.ON",
        "modalDesc": "Search or select an app to get added to the home page",
        "titleRequired": "Card title is required",
        "linkRequired": "Card link is required",
        "searchPlaceholder": "Search App"
    },
    "onboardingPortal": {
        "onboardAppBtn": "Onboarding Portal",
        "heading": "Onboarding Portal",
        "subHeading": "Review your app, onboard new ones, and share management access with your team.",
        "modules": {
            "home": "Home",
            "apps": "Apps",
            "appsLabel": "Apps",
            "qna": "Q&A",
            "qnaLabel": "Question & Answer",
            "review": "Review",
            "reviewLabel": "Review",
            "onboardApp": "Onboard new app",
            "manageApp": "Manage apps",
            "defaultApps": "Default Apps",
            "onboardQnA": "Onboard QnA",
            "manageQnA": "Manage QnA",
            "reviewDashboard": "Reviewer Dashboard",
            "reviewApps": "Review Apps",
            "reviewQnA": "Review Q&A"
        },
        "appOnboardingForm": {
            "formHeading": "Onboard New App",
            "successAlert": "App onboarded successfully!",
            "appTitleLabel": "App Title",
            "appTitleTooltip": "App name to be displayed",
            "appTitlePlaceholder": "App name to be displayed",
            "appTitleError": "App title is required",
            "appSubTitleLabel": "App SubTitle",
            "appSubTitleTooltip": "Sub-Title of the app",
            "appSubTitlePlaceholder": "Sub-Title of the app",
            "appSubTitleError": "App SubTitle is required",
            "appUrlLabel": "App URL",
            "appUrlTooltip": "Target url of the app",
            "appUrlPlaceholder": "Target url of the app",
            "appUrlError": "App URL is required",
            "appKeywordsLabel": "synKeywords (comma separated)",
            "appKeywordsTooltip": "Fill in synonyms which users might use to find the app and separate through comma",
            "appKeywordsPlaceholder": "Fill in synonyms which users might use to find the app and separate through comma",
            "appKeywordsError": "Keywords are required",
            "appCompaniesAllowedLabel": "Companies Allowed",
            "appCompaniesAllowedTooltip": "List of all the companies where this app is allowed, if allowed for all then leave it blank.",
            "appCompaniesAllowedInfoMessage": "List of all the companies where this app is allowed, if allowed for all then leave it blank.",
            "appCompaniesAllowedOtherLabel": "Other Companies Allowed",
            "appCompaniesAllowedOtherPlaceholder": "Specify other companies allowed",
            "appCompaniesRestrictedLabel": "Companies Restricted",
            "appCompaniesRestrictedTooltip": "List of all the companies where this app is NOT allowed, if no restriction for the app then leave it blank.",
            "appCompaniesRestrictedInfoMessage": "List of all the companies where this app is NOT allowed, if no restriction for the app then leave it blank.",
            "appCompaniesRestrictedOtherLabel": "Other Companies Restricted",
            "appCompaniesRestrictedOtherPlaceholder": "Specify other companies restricted",
            "appTooltipLabel": "Tooltip (mention all languages, if different name to be displayed)",
            "appTooltipTooltip": "mention all languges, if different name to be displayed e.g. EN- This is My HR tooltip, DE- Dies ist mein HR-Tooltip",
            "appTooltipPlaceholder": "mention all languges, if different name to be displayed e.g. EN- This is My HR tooltip, DE- Dies ist mein HR-Tooltip",
            "appTooltipError": "Tooltip is required",
            "appIconLabel": "Upload App Icon",
            "appIconTooltip": "Upload App Icon",
            "previewAppBtn": "Preview App",
            "cancelBtn": "Cancel",
            "closeBtn": "Close",
            "submitAppBtn": "Submit App",
            "updateAppBtn": "Update App",
            "editAppBtn": "Edit App",
            "appTitlePreview": "Title",
            "appSubTitlePreview": "Subtitle",
            "appUrlPreview": "URL",
            "appKeywordsPreview": "Keywords",
            "appCompaniesAllowedPreview": "Companies Allowed",
            "appCompaniesRestrictedPreview": "Companies Restricted",
            "appTooltipPreview": "Tooltip",
            "message": "Once an app is submitted, it enters a Pending status and moves through a defined review lifecycle — progressing from Pending → Approved (under review/testing) → In QA (formally approved and being verified) → In Production (live and visible to end users on MyHelp), or it may be Rejected if it doesn't meet criteria, in which case the stakeholder can edit and resubmit."
        },
        "qnaOnboardingForm": {
            "formHeading": "Onboard New QnA",
            "successAlert": "QnA onboarded successfully!",
            "qnaQuestionLabel": "Question",
            "qnaQuestionTooltip": "Enter the question for the QnA item",
            "qnaQuestionPlaceholder": "Enter the question",
            "qnaQuestionError": "Question is required",
            "qnaAnswerLabel": "Answer",
            "qnaAnswerTooltip": "Enter the answer for the QnA item",
            "qnaAnswerPlaceholder": "Enter the answer for the question",
            "qnaAnswerError": "Answer is required",
            "qnaCategoryLabel": "Category",
            "qnaCategoryTooltip": "Select the category for the QnA item",
            "qnaCategoryPlaceholder": "Select the category for the QnA item",
            "qnaCategoryError": "Category is required",
            "qnaCategoryOtherLabel": "Other Category",
            "qnaCategoryOtherPlaceholder": "Enter custom category",
            "qnaCompaniesAllowedLabel": "Companies Allowed",
            "qnaCompaniesAllowedTooltip": "List of all the companies where this app is allowed, if allowed for all then leave it blank.",
            "qnaCompaniesAllowedInfoMessage": "List of all the companies where this app is allowed, if allowed for all then leave it blank.",
            "qnaCompaniesAllowedOtherLabel": "Other Companies Allowed",
            "qnaCompaniesAllowedOtherPlaceholder": "Specify other companies allowed",
            "qnaCompaniesRestrictedLabel": "Companies Restricted",
            "qnaCompaniesRestrictedTooltip": "List of all the companies where this app is NOT allowed, if no restriction for the app then leave it blank.",
            "qnaCompaniesRestrictedInfoMessage": "List of all the companies where this app is NOT allowed, if no restriction for the app then leave it blank.",
            "qnaCompaniesRestrictedOtherLabel": "Other Companies Restricted",
            "qnaCompaniesRestrictedOtherPlaceholder": "Specify other companies restricted",
            "previewQnABtn": "Preview QnA",
            "cancelBtn": "Cancel",
            "submitQnABtn": "Submit Question & Answer",
            "updateQnABtn": "Update Question & Answer",
            "editQnABtn": "Edit Question & Answer",
            "addNewQnABtn": "Add Question & Answer",
            "qnaQuestionPreview": "Question",
            "qnaAnswerPreview": "Answer",
            "qnaCompaniesAllowedPreview": "Companies Allowed",
            "qnaCompaniesRestrictedPreview": "Companies Restricted",
            "message": "Once  an Q&A entry is submitted, it enters a Pending status and moves through a defined review lifecycle — progressing from Pending → Approved (under review/testing) → In QA (formally approved and being verified) → In Production (live and visible to end users on MyHelp), or it may be Rejected if it doesn't meet criteria, in which case the stakeholder can edit and resubmit."
        },
        "manageBtn": "Manage",
        "refreshBtn": "Refresh",
        "exportBtn": "Export",
        "exportCsvBtn": "CSV",
        "exportExcelBtn": "Excel",
        "exportAppsCsvBtn": "Export Apps as CSV",
        "exportAppsExcelBtn": "Export Apps as Excel",
        "exportQnACsvBtn": "Export QnA as CSV",
        "exportQnAExcelBtn": "Export QnA as Excel",
        "approveBtn": "Approve",
        "rejectBtn": "Reject",
        "toQABtn": "Move to QA",
        "toProdBtn": "Move to Prod",
        "editBtn": "Edit",
        "viewBtn": "View",
        "closeBtn": "Close",
        "dashboard": {
            "appsTitle": "Accessible Apps",
            "appsText": "Apps available to you through ownership or team sharing.",
            "qnaTitle": "Question & Answer",
            "qnaText": "Q&A available to you through ownership or team sharing."
        },
        "modalLabel": {
            "reviewAppTitle": "Review App for Onboarding",
            "reviewQnATitle": "Review QnA for Onboarding",
            "owner": "Owner",
            "createdOn": "Created On",
            "status": "Status",
            "url": "URL",
            "tooltip": "Tooltip",
            "companiesAllowed": "Companies Allowed",
            "companiesRestricted": "Companies Restricted",
            "keywords": "Keywords",
            "reviewerComments": "Review Comments",
            "category": "Category",
            "question": "Question",
            "answer": "Answer",
            "mail": "Mail"
        },
        "statusLabel": {
            "pending": "Pending",
            "approved": "Approved",
            "rejected": "Rejected",
            "onhold": "On Hold",
            "unknown": "Unknown",
            "all": "All",
            "inQA": "In QA",
            "inProd": "In Production"
        },
        "activityLabel": {
            "allowed": "Allowed",
            "restricted": "Restricted"
        },
        "tableHeaders": {
            "status": "Status",
            "action": "Action",
            "icon": "Icon",
            "title": "Title",
            "subTitle": "Sub Title",
            "question": "Question",
            "answer": "Answer",
            "category": "Category",
            "owner": "Owner",
            "description": "Description",
            "apps": "Apps",
            "qna": "Question & Answer",
            "defaultApps": "Default Apps",
            "defaultAppsActivity": "Default Apps Changes",
            "search": "Search",
            "selectCompany": "Select Company",
            "otherCompany": "Other Company Name",
            "selectAll": "Select All",
            "company": "Company",
            "update": "Update",
            "comments": "Comments"
        },
        "noData": {
            "dashboardEmpty": "No Apps or Q&A have been added",
            "dashboardAppsEmpty": "No Apps have been added",
            "dashboardQnAEmpty": "No Q&A have been added",
            "reviewDashboardEmpty": "No Apps or Q&A have been submitted for review.",
            "reviewAppsEmpty": "No Apps have been submitted for review.",
            "reviewQnAEmpty": "No Q&A have been submitted for review."
        },
        "manageApp": {
            "heading": "Manage Apps",
            "subHeading": "Only app you own or have been granted access to are shown here."
        },
        "manageQnA": {
            "heading": "Manage QnA",
            "subHeading": "Only QnA you own or have been granted access to are shown here."
        },
        "defaultApps": {
            "heading": "Default Apps",
            "subHeading": "These are the apps which are available for all user per default. You can change the shown apps by activating or deactivating apps.",
            "searchPlaceholder": "Search for Apps"
        },
        "reviewDashboard": {
            "heading": "Review Dashboard",
            "subHeading": "Review and approve or reject pending app onboarding requests. Your timely reviews help us maintain a relevant and useful app collection for everyone."
        },
        "reviewApps": {
            "heading": "Review Apps",
            "subHeading": "Review and approve or reject pending app onboarding requests. Your timely reviews help us maintain a relevant and useful app collection for everyone."
        },
        "reviewQnA": {
            "heading": "Review QnA",
            "subHeading": "Review and approve or reject pending QnA onboarding requests. Your timely reviews help us maintain a relevant and useful QnA collection for everyone."
        },
        "reviewQueue": {
            "heading": "Review Queue",
            "subHeading": "Review and approve or reject pending app onboarding requests. Your timely reviews help us maintain a relevant and useful app collection for everyone."
        },
        "activityLog": {
            "heading": "Activity Log"
        },
        "quickActions": {
            "title": "Quick Actions",
            "onboardNewApp": "Onboard New App",
            "manageApps": "Manage Apps",
            "defaultApps": "Default Apps",
            "onboardNewQnA": "Onboard Question & Answer",
            "manageQnA": "Manage Question & Answer",
            "reviewerDashboard": "Reviewer Dashboard",
            "reviewApps": "Review Onboarded Apps",
            "reviewQnA": "Review Onboarded Q&A"
        }
    },
    "sourceSelector": {
        "title": "Select source",
        "allSources": "All Sources",
        "allSourcesDesc": "Search across all internal E.ON information sources",
        "eonKnowledgeBase": "E.ON Knowledge base",
        "eonKnowledgeBaseDesc": "Access general company knowledge",
        "eonMyItOrder": "E.ON My IT Order",
        "eonMyItOrderDesc": "Manage and track IT service orders",
        "eonItKnowledgeBase": "E.ON IT Knowledge base",
        "eonItKnowledgeBaseDesc": "Find IT-related information and solutions",
        "myGenius": "My Genius",
        "myGeniusDesc": "Explore internal learning courses and materials",
        "confluenceAll": "Confluence (All)",
        "confluenceAllDesc": "Search collaborative documentation",
        "sharepointAll": "Sharepoint (All)",
        "sharepointAllDesc": "Browse shared files and resources",
        "eonApps": "E.ON Apps",
        "eonAppsDesc": "Discover and access company applications",
        "hrPolicies": "HR Policies",
        "hrPoliciesDesc": "Access HR policies and guidelines",
        "compass": "Compass",
        "compassDesc": "Explore E.ON Intranet",
        "back": "Back",
        "search": "Search...",
        "noMatches": "No matches"
    },
    "compassScopeSelector": {
        "title": "Select Business Unit",
        "iconLabel": "Search Scope",
        "localSearch": "Local Search",
        "compassWideSearch": "Compass-wide Search",
        "resetToCompassWide": "Reset to Compass-wide search",
        "switchToLocal": "Switch to Local search",
        "localDescription": "Search within your company and public posts",
        "compassWideDescription": "Search across all business units"
    },
    "errorMessages": {
        "azureAiContentViolation": "The response was filtered due to the query triggering Azure OpenAI's content management policy. Please modify your query and retry."
    }
}
